// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 524 ? "app" : chunkId) + "." + {"389":"9b0855633078726efb99","524":"9ecda3070cfecb3e44c8"}[chunkId] + ".css";
};